import React from 'react'
import NoBubbleLayout from '../Layout/NoBubbleLayout';
import { Link } from 'react-router-dom';
import logo from '../../assets/INTERNATIONAL-CONFERENCE-ALERTS.png'

const mediaPartnerConfDetails = [
  {
    logo: {logo},
    altText: 'International Conference Alerts',
    websiteUrl: 'https://internationalconferencealerts.com'
  }
];

const MediaPartner = () => {
  return (
    <NoBubbleLayout heading={'Media Partners'}>
      <div className='flex justify-center'>
        {mediaPartnerConfDetails.length > 0 ? (
          <div className='w-full max-w-[50rem] border-[2px] bg-white border-gray-200 rounded-[0.5em] flex flex-col sm:gap-0 gap-[1.5em] items-stretch mt-[1em] overflow-hidden text-[1em]'>
            {mediaPartnerConfDetails.map((data, i) => (
              <div key={i} className='flex flex-col items-center p-6 hover:bg-gray-50 transition-colors'>
                <a 
                  href={data.websiteUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className='flex flex-col items-center text-center group'
                >
                  <img 
                    src={logo} 
                    alt={data.altText}
                    className='max-w-[200px] max-h-[100px] object-contain mb-4 group-hover:scale-105 transition-transform'
                  />
                  {/* <span className='text-gray-700 group-hover:text-blue-600 transition-colors'>
                    {data.altText}
                  </span> */}
                  <span className='text-sm text-blue-500 mt-1 group-hover:underline'>
                    Visit Website
                  </span>
                </a>
              </div>
            ))}
          </div>
        ) : (
          <p className='w-[100%] border-[2px] border-gray-200 rounded-[1em] flex items-center justify-center min-h-[10em] mt-[2em]'>
            No media partners available
          </p>
        )}
      </div>
    </NoBubbleLayout>
  )
}

export default MediaPartner